var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.18 0.970006C0.981667 0.970006 0.81875 1.03376 0.69125 1.16126C0.56375 1.28876 0.5 1.45167 0.5 1.65001C0.5 1.84834 0.56375 2.01126 0.69125 2.13876C0.81875 2.26626 0.981667 2.33001 1.18 2.33001V2.56376C1.19417 3.49876 1.52708 4.29917 2.17875 4.96501L3.62375 6.41001L2.17875 7.85501C1.52708 8.52084 1.19417 9.32126 1.18 10.2563V10.49C0.981667 10.49 0.81875 10.5538 0.69125 10.6813C0.56375 10.8088 0.5 10.9717 0.5 11.17C0.5 11.3683 0.56375 11.5313 0.69125 11.6588C0.81875 11.7863 0.981667 11.85 1.18 11.85H1.86H7.98C8.17833 11.85 8.34125 11.7863 8.46875 11.6588C8.59625 11.5313 8.66 11.3683 8.66 11.17C8.66 10.9717 8.59625 10.8088 8.46875 10.6813C8.34125 10.5538 8.17833 10.49 7.98 10.49V10.2563C7.96583 9.32126 7.63292 8.52084 6.98125 7.85501L5.53625 6.41001L6.98125 4.96501C7.63292 4.29917 7.96583 3.49876 7.98 2.56376V2.33001C8.17833 2.33001 8.34125 2.26626 8.46875 2.13876C8.59625 2.01126 8.66 1.84834 8.66 1.65001C8.66 1.45167 8.59625 1.28876 8.46875 1.16126C8.34125 1.03376 8.17833 0.970006 7.98 0.970006H7.3H1.18ZM6.62 10.2563V10.49H2.54V10.2563C2.55417 9.68959 2.7525 9.20792 3.135 8.81126L4.58 7.36626L6.025 8.81126C6.4075 9.22209 6.60583 9.70376 6.62 10.2563Z",
    fill: "#ADB5BD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.16,
    height: 12,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.5 12.41)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourGlass);
export default __webpack_public_path__ + "static/media/hour-glass.170ab3f83559bb2604e46ff8d0342b71.svg";
export { ForwardRef as ReactComponent };